import { render, staticRenderFns } from "./TaskModal.vue?vue&type=template&id=0e9c0855&"
import script from "./TaskModal.vue?vue&type=script&lang=ts&"
export * from "./TaskModal.vue?vue&type=script&lang=ts&"
import style0 from "./TaskModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports